import clsx from 'clsx';

export function Skeleton({ className }: { className?: string }) {
  return (
    <div className={clsx(
      'bg-gradient-to-r from-panel-2 via-border-light to-panel-2 bg-[length:200%_100%] animate-pulse rounded',
      className,
    )} style={{ animationDuration: '1.6s' }} />
  );
}

export function CardSkeleton() {
  return (
    <div className="bg-panel-2 border border-border rounded-lg p-3 space-y-2">
      <Skeleton className="h-4 w-3/4" />
      <Skeleton className="h-3 w-1/2" />
      <div className="flex gap-1">
        <Skeleton className="h-4 w-12" />
        <Skeleton className="h-4 w-16" />
      </div>
      <Skeleton className="h-3 w-1/3" />
    </div>
  );
}

export function KanbanSkeleton() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-3">
      {[1, 2, 3, 4, 5].map((i) => (
        <div key={i} className="bg-panel border border-border rounded-xl p-3 space-y-2 min-h-[400px]">
          <Skeleton className="h-6 w-1/2 mb-3" />
          <CardSkeleton />
          <CardSkeleton />
          <CardSkeleton />
        </div>
      ))}
    </div>
  );
}

export function KpiCardSkeleton() {
  return (
    <div className="card relative pl-5">
      <div className="absolute left-0 top-3 bottom-3 w-1 rounded-r-sm bg-border-light" />
      <Skeleton className="h-3 w-24 mb-2" />
      <Skeleton className="h-7 w-16 mb-2" />
      <Skeleton className="h-3 w-32" />
    </div>
  );
}

export function ChartSkeleton({ height = 'h-56' }: { height?: string }) {
  return (
    <div className="card">
      <Skeleton className="h-4 w-32 mb-2" />
      <Skeleton className="h-3 w-40 mb-4" />
      <Skeleton className={clsx('w-full', height)} />
    </div>
  );
}
